import exploreSm from '../../Assets/Images/solutions-phone-sm.svg';
import exploreLg from '../../Assets/Images/solutions-phone-lg.svg';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

export default function Explore() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const { t } = useTranslation();
  const width = windowSize.width;
  const isMobile = width <= 767;

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section className="solutions__explore">
      <div className="solutions__explore-text">
        <h3>{t('solutions.explore.title')}</h3>
        <p>{t('solutions.explore.description')}</p>
      </div>
      <img
        src={isMobile ? exploreSm : exploreLg}
        alt="explore"
        loading="lazy"
      />
    </section>
  );
}
